import { render, staticRenderFns } from "./ComparatorBody.vue?vue&type=template&id=1cca84ca"
import script from "./ComparatorBody.vue?vue&type=script&lang=js"
export * from "./ComparatorBody.vue?vue&type=script&lang=js"
import style0 from "./ComparatorBody.vue?vue&type=style&index=0&id=1cca84ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports